(() => {
console.log('Paid offer build: Oct19-debug-1');

  const CODE = 'FRESH-26';
  //   const CAMPAIGN = 'paid_free_shipping';
  const PAID_MEDIUMS = ['cpc', 'ppc', 'paid_social', 'paid'];

  // Use a new key for each separate promotion.
  const KEY = 'terry:shipping-offer:fall-2026:v1';
  const RETURN_PARAM = 'terry_offer_return';

  // Example: remember this promotion's display state for seven days.
  const LIFETIME = 7 * 24 * 60 * 60 * 1000;

  let state = null;

  function readState() {
    try {
      const saved = JSON.parse(localStorage.getItem(KEY));

      if (
        ['eligible', 'clicked'].includes(saved?.status) &&
        Number.isFinite(saved.expiresAt) &&
        saved.expiresAt > Date.now()
      ) {
        return saved;
      }

      localStorage.removeItem(KEY);
    } catch {
      // Blocked storage or invalid saved data.
    }

    return null;
  }

  function saveState(next) {
    try {
      localStorage.setItem(KEY, JSON.stringify(next));
      state = next;
      return true;
    } catch {
      return false;
    }
  }

  function setView(view) {
    document.documentElement.dataset.adOfferView = view;
  }

const url = new URL(location.href);
const returnToken = url.searchParams.get(RETURN_PARAM);

state = readState();

const hasFreshPendingClick =
  state?.status === 'clicked' &&
  typeof state.pendingToken === 'string' &&
  Number.isFinite(state.pendingAt) &&
  Date.now() >= state.pendingAt &&
  Date.now() - state.pendingAt < 2 * 60 * 1000;

console.log('Offer return diagnostic', {
  url: location.href,
  returnToken,
  savedState: state,
  hasFreshPendingClick
});

if (returnToken !== null || hasFreshPendingClick) {
  const expectedReturn =
    hasFreshPendingClick &&
    (returnToken === null || state.pendingToken === returnToken);



    if (expectedReturn) {
      const consumed = saveState({
        status: 'clicked',
        expiresAt: state.expiresAt
      });

      // Only show once we can persist that it has been consumed.
      setView(consumed ? 'confirmation' : '');
    } else {
      setView('');
    }

    // Remove our marker without reloading; preserve UTMs and hash.
    url.searchParams.delete(RETURN_PARAM);

    try {
      history.replaceState(
        history.state,
        '',
        url.pathname + url.search + url.hash
      );
    } catch {
      // A remaining marker cannot replay a consumed confirmation.
    }
  } else {
    const medium =
      (url.searchParams.get('utm_medium') || '').toLowerCase();

    // const matchesPaidCampaign =
    //   (url.searchParams.get('utm_campaign') || '').toLowerCase() === CAMPAIGN.toLowerCase() &&
    //   PAID_MEDIUMS.includes(medium);
    const matchesPaidCampaign = PAID_MEDIUMS.includes(medium);

    if (!state && matchesPaidCampaign) {
      const eligible = {
        status: 'eligible',
        expiresAt: Date.now() + LIFETIME
      };

      // Still allow the initial message if storage is unavailable.
      if (!saveState(eligible)) state = eligible;
    }

    const MAX_INITIAL_VIEWS = 2;

    if (state?.status === 'eligible') {
      const views = Number.isInteger(state.initialViews)
        ? Math.max(0, state.initialViews)
        : 0;

      if (views < MAX_INITIAL_VIEWS) {
        const next = {
          ...state,
          initialViews: views + 1
        };

        // Keep the in-memory state current even if storage fails.
        saveState(next);
        state = next;

        setView('initial');
      } else {
        setView('');
      }
    } else {
      setView('');
    }

  }

  // Delegation supports Replo content inserted after script execution.
  document.addEventListener('click', async (event) => {
    if (!(event.target instanceof Element)) return;

    const button = event.target.closest(
        '[data-id="js-ad-offer-apply"]'
    );

    if (!button) return;

    event.preventDefault();

    if (
      state?.status !== 'eligible' ||
      state.expiresAt <= Date.now()
    ) {
      setView('');
      return;
    }

    try {
    const root = window.Shopify?.routes?.root || '/';

    const response = await fetch(root + 'cart/update.js', {
        method: 'POST',
        headers: {
        'Content-Type': 'application/json'
        },
        body: JSON.stringify({
        attributes: {
            offer_id: 'paid_shipping_fall_2026',
            offer_action: 'accepted',
            offer_code: CODE
        }
        })
    });

    if (!response.ok) {
        throw new Error(`Cart attribute update failed: ${response.status}`);
    }
    } catch (error) {
    console.warn('Offer tracking could not be saved', error);
    // Continue applying the discount even if tracking fails.
    }

    const token = crypto.randomUUID();

    const stored = saveState({
        status: 'clicked',
        expiresAt: state.expiresAt,
        pendingToken: token,
        pendingAt: Date.now()
    });

    const destination = new URL(location.href);
    destination.searchParams.delete(RETURN_PARAM);

    if (stored) {
      destination.searchParams.set(RETURN_PARAM, token);
    }

    const returnPath =
      destination.pathname + destination.search + destination.hash;

    const discountUrl =
        '/discount/' + encodeURIComponent(CODE) +
        '?redirect=' + encodeURIComponent(returnPath);

    console.log('Offer outgoing diagnostic', {
        stored,
        returnPath,
        discountUrl
    });

    location.assign(discountUrl);

  });

  // Don't replay the confirmation from the browser's back/forward cache.
  window.addEventListener('pageshow', (event) => {
    if (!event.persisted) return;

    state = readState();

    const views = Number.isInteger(state?.initialViews)
      ? state.initialViews
      : 0;

    setView(
      state?.status === 'eligible' &&
      state.expiresAt > Date.now() &&
      views < 2
        ? 'initial'
        : ''
    );
  });

})();
